export default "__VITE_ASSET__B2IB5hum__"